export default "__VITE_ASSET__DHiTP_l9__"